import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Divider from "@material-ui/core/Divider";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Typography from "@material-ui/core/Typography";
import {
  Box,
  Card,
  CardContent,
  Grid,
  Link,
  Button,
  FormLabel,
} from "@material-ui/core";
import { FileIcon, defaultStyles } from "react-file-icon";
import SvgIcon from "@material-ui/core/SvgIcon";
import { NavLink as RouterLink } from "react-router-dom";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
  inline: {
    display: "inline",
  },
}));

const KmDocumentList = ({ title, backFunction, rows, reloadView, ...rest }) => {
  const classes = useStyles();

  return (
    <Box mt={1} mb={1}>
      <Box mb={1}></Box>

      <Card>
        <CardContent>
          <Box>
            <Button
              color="secondary"
              variant="contained"
              startIcon={<ArrowBackIcon />}
              onClick={backFunction}
            >
              Powrót
            </Button>
          </Box>
          <Box mb={2} mt={1}>
            <FormLabel>{title}</FormLabel>
          </Box>
          <List className={classes.root}>
            {rows.map((row, rowindex) => {
              return (
                <>
                  <Divider variant="inset" component="li" />

                  <ListItem alignItems="flex-start">
                    <ListItemAvatar>
                      <SvgIcon>
                        <FileIcon
                          extension={row.fileType}
                          {...defaultStyles[row.fileType]}
                        />
                      </SvgIcon>
                    </ListItemAvatar>
                    <ListItemText
                      primary={
                        <Typography color="textPrimary" variant="body1">
                          <Link
                            component={RouterLink}
                            to={`/dokumenty/dokument/${row.structNodeId}`}
                          >
                            {row.documentName}
                          </Link>
                        </Typography>
                      }
                      secondary={
                        <React.Fragment>
                          <Grid container spacing={2}>
                            <Grid item sm={6} xs={12}>
                              {row.filePath ? (
                                <Link
                                  component={RouterLink}
                                  className={classes.inline}
                                  onClick={() => reloadView(row.structNodeId)}
                                  variant="body2"
                                  color="textPrimary"
                                  to={`/dokumenty/0/${row.structNodeId}`}
                                >
                                  {row.filePath}
                                </Link>
                              ) : (
                                <></>
                              )}
                              {/* <Typography
                                component="span"
                                variant="body2"
                                className={classes.inline}
                                color="textPrimary"
                              >
                                {row.filePath}
                              </Typography> */}
                            </Grid>
                            <Grid item sm={6} xs={12}>
                              <Box
                                display="flex"
                                justifyContent="flex-end"
                                fullWidth
                              >
                                <Typography
                                  component="span"
                                  variant="subtitle2"
                                  className={classes.inline}
                                  color="textPrimary"
                                >
                                  {row.createdBy} ({row.createdAt})
                                </Typography>
                              </Box>
                            </Grid>
                          </Grid>
                        </React.Fragment>
                      }
                    />
                  </ListItem>
                </>
              );
            })}

            <Divider variant="inset" component="li" />
          </List>
        </CardContent>
      </Card>
    </Box>
  );
};

export default KmDocumentList;
